import React, { ReactNode } from 'react';
import { clsx } from 'clsx';

import styles from './Stat.module.scss';

export const StatTypes = [
  'stat-xs',
  'stat-sm',
  'stat-md',
  'stat-lg',
  'stat-xl'
] as const;
type StatTypesType = (typeof StatTypes)[number];

interface StatProps extends React.ComponentPropsWithoutRef<'div'> {
  value: string | number | ReactNode;
  label?: string;
  type?: StatTypesType;
  wrapperClassName?: string;
  labelClassName?: string;
  valueClassName?: string;
  labelAfterValue?: boolean;
}

export const Stat = ({
  value,
  label,
  type,
  wrapperClassName,
  labelClassName,
  valueClassName,
  labelAfterValue = false,
  ...rest
}: StatProps) => {
  const labelElement = (
    <span className={clsx(styles.statLabel, labelClassName)}>{label}</span>
  );

  return (
    <div
      className={clsx(styles.stat, type && styles[type], wrapperClassName)}
      {...rest}
    >
      {!labelAfterValue && labelElement}
      <div className={clsx(styles.statValue, valueClassName)}>{value}</div>
      {labelAfterValue && labelElement}
    </div>
  );
};
